import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  viewBox: "0 0 25.4 25.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M59.999 72.377h-25.4v25.4h25.4v-12.7h-12.7z",
      style: {"fill":"#454444","fill-opacity":"1","fill-rule":"nonzero","stroke":"none","stroke-width":".264583"},
      transform: "translate(-34.599 -72.377)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M34.599 72.377v25.4h25.4l-12.7-12.7 12.7-12.7zM59.999 97.777v-12.7zM59.999 85.077h-12.7z",
      style: {"fill":"#727174","fill-opacity":"1","fill-rule":"nonzero","stroke":"none","stroke-width":".264583"},
      transform: "translate(-34.599 -72.377)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M34.599 72.377v25.4l25.4-25.4z",
      style: {"fill":"#949196","fill-opacity":"1","fill-rule":"nonzero","stroke":"none","stroke-width":".264583"},
      transform: "translate(-34.599 -72.377)"
    }, null, -1)
  ])))
}
export default { render: render }